import {Component, computed, input, output, signal} from '@angular/core';
import {LifeBuoyIcon, LucideAngularModule, MailIcon, MessagesSquareIcon} from 'lucide-angular';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';

@Component({
  selector: 'app-contact-support',
  imports: [
    LucideAngularModule,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './contact-support.component.html',
  styleUrl: './contact-support.component.scss'
})
export class ContactSupportComponent {

  public readonly routes = {
    faq: RouteGenerator.abs(UI_ROUTES.public.faq)
  };

  public readonly supportEmailSubject = input('Contact');
  public readonly supportWhatsappMessage = input('Hopla! Pouvez-vous m\'aider?');
  public readonly ok = output<void>();

  public readonly showDialog = signal(false);

  public readonly supportEmail = 'info@hopla.ch';
  public readonly supportEmailUrl = computed(() => `mailto:${this.supportEmail}?subject=${this.supportEmailSubject()}`);
  public readonly whatsappPhone = '077 478 45 01';
  public readonly supportWhatsappUrl = computed(() => `https://wa.me/41774784501?text=${this.supportWhatsappMessage()}`);

  public readonly icons = {
    mail: MailIcon,
    whatsapp: MessagesSquareIcon,
    help: LifeBuoyIcon
  };

  public okClicked(): void {
    this.showDialog.set(false);
    this.ok.emit();
  }

  public show(): void {
    this.showDialog.set(true);
  }

  public toggleShowHelp(): void {
    this.showDialog.update(show => !show);
  }
}
